enum EPermission {
  EditAfterPricing = "editAfterPricing",
  EditItem = "editItem",
  EditOnHold = "editOnHoldItem",
}

export default EPermission;
